export const coverStory = {
  edition: "深挖档案 · 总第 09 期",
  date: "2026.09.08",
  kicker: "封面深挖 / 真实身份",
  title: "当「公开信息」拼不出全貌，真正的故事藏在身份之下",
  stand:
    "背后金主、一段隐藏关系、几屏被删掉的私下聊天——我们把散落各处的碎片，按时间顺序接成一条完整的线。所谓深挖，不过是从最不起眼的蛛丝马迹里，找到那个不敢写进履历的人。",
  byline: "呱呱编辑部 · 深挖组",
  readTime: "约 18 分钟",
  tags: ["真实身份", "背后金主", "时间线复盘"],
};

export const leadCards = [
  {
    kicker: "身份复盘",
    title: "从「神秘操盘手」到实名，这桩身份揭秘拖了半年，线索全藏在旧采访里",
    meta: "5 分钟读完 · 已有 8.2 万人参与深挖",
    trend: true,
  },
  {
    kicker: "资本快讯",
    title: "一家新消费品牌背后站着同一批出资人，注册地却在一年内改了三次",
    meta: "新增 3 处实锤 · 正更新中",
    hot: true,
  },
  {
    kicker: "关系浮标",
    title: "两条看似无关的动态，被同一张旧照片串成了同框证据",
    meta: "评论区已跟进 4.1k 条线索",
  },
  {
    kicker: "今日争议",
    title: "这份被反复转发的「未公开名单」，到底有几成经得起对证？",
    meta: "今日热度 12 万+ · 争议中",
  },
];

export const statHighlights = [
  { label: "本周跟进事件", value: "47", unit: "起" },
  { label: "实锤交叉验证", value: "1,286", unit: "条" },
  { label: "读者补刀线索", value: "9,740", unit: "条" },
  { label: "全网讨论热度", value: "312", unit: "万" },
];

export const topicTags = [
  { name: "真实身份", heat: 96, live: true },
  { name: "背后金主", heat: 88, live: false },
  { name: "隐藏关系", heat: 91, live: true },
  { name: "私下聊天", heat: 84, live: false },
  { name: "未公开信息", heat: 77, live: false },
  { name: "融资实锤", heat: 69, live: false },
  { name: "资本退出", heat: 63, live: false },
  { name: "旧闻再挖", heat: 58, live: false },
  { name: "同框疑云", heat: 73, live: true },
  { name: "高管异动", heat: 55, live: false },
  { name: "平台下架", heat: 47, live: false },
  { name: "辟谣与反转", heat: 66, live: false },
];

export const headlineFeed = [
  { tag: "实锤新增", title: "投资人退场前的最后一次公开露面，时间对不上账", comments: "1.8k", time: "12 分钟前", hot: false },
  { tag: "身份线索", title: "一处注册地址沿用了 11 年，直到今年才换——为什么偏偏是现在？", comments: "966", time: "38 分钟前", hot: false },
  { tag: "隐藏关系", title: "一句「只是商业往来」之外，合作方晒出的旧合照说明了什么", comments: "2.3k", time: "1 小时前", hot: false },
  { tag: "私下聊天", title: "一张打码截图流出：对话里的口径，和公开说法差得很远", comments: "3.7k", time: "2 小时前", hot: true },
  { tag: "未公开信息", title: "被一笔带过的关键数据，藏在招股书附录第 137 页", comments: "1.2k", time: "3 小时前", hot: false },
  { tag: "人物追踪", title: "这位联合创始人的公开履历，为什么突然被清空了一段", comments: "4.0k", time: "5 小时前", hot: true },
  { tag: "金主起底", title: "同一笔出资被拆进四家公司，绕了几层才回到那位出资人名下", comments: "1.6k", time: "6 小时前", hot: false },
  { tag: "关系网", title: "两人相隔十年的两次同框，被网友用行程表交叉验证成真", comments: "2.9k", time: "8 小时前", hot: false },
];

export const hotTopics = [
  { rank: 1, title: "「被公开」的另一面：我们该在哪里停下来", views: "86 万", trend: "up" },
  { rank: 2, title: "旧采访逐句重读：所有破绽都提前说过", views: "63 万", trend: "up" },
  { rank: 3, title: "一场饭局照引发的资本关系大猜想", views: "51 万", trend: "flat" },
  { rank: 4, title: "删掉的动态，能不能作为证据被引用", views: "39 万", trend: "up" },
  { rank: 5, title: "打码截图满天飞，读者该如何交叉验证", views: "28 万", trend: "down" },
];

export const backerCard = {
  img: "https://readdy.ai/api/search-image?query=cinematic%20noir%20editorial%20photograph%20of%20a%20financial%20district%20skyline%20at%20deep%20dusk%20with%20warm%20amber%20window%20lights%20and%20dark%20blue%20shadows%20fading%20into%20charcoal%2C%20moody%20atmospheric%20cityscape%20with%20layered%20buildings%20and%20soft%20light%20haze%2C%20documentary%20magazine%20reportage%20style%2C%20high%20detail%2C%20dramatic%20contrast%20and%20grain%2C%20no%20text&width=1280&height=760&seq=backer-city-0908&orientation=landscape",
  title: "一页工商信息背后：出资人如何在三层持股结构里「隐身」",
  desc: "从单一实缴记录出发，我们沿着股权穿透往回走——每一步改口、每一处地址迁移，都是背后金主想要藏起身份留下的脚印。",
  checks: [
    { k: "持股穿透", v: "3 层结构 → 指向同一出资人" },
    { k: "地址迁移", v: "两年内 3 处注册地，均为同一代理所代办" },
    { k: "资金流向", v: "多笔关联转入，标注口径前后不一" },
    { k: "目前进展", v: "仍在交叉验证，实锤待补" },
  ],
  sources: ["公开工商信息", "法院裁判文书", "融资公告", "地方公示"],
};

export const moneyList = [
  { title: "一家「无股权关系」的公司，为何共用同一部办公电话", hot: "2.1k" },
  { title: "融资轮次的背后金主名单，比对外公布的多了两个人", hot: "1.5k" },
  { title: "品牌创始人退股后，操盘仍在这边——谁来签字？", hot: "980" },
];

export const relationNodes = [
  { tag: "实锤", title: "A 与 B：同一项目的两只基金，出资时间精确到同一天", meta: "工商与公示双向佐证" },
  { tag: "强关联", title: "C 与 D：三年里共同出席五场同城活动，却从未同框出镜", meta: "行程表交叉比对" },
  { tag: "待验证", title: "E 与 F：网络地址指向同一办公室，未公开信息存疑", meta: "读者提供 4 组线索" },
  { tag: "辟谣", title: "G 与 H：同框照经查系旧图，隐藏关系传闻不成立", meta: "实锤失效，已反转" },
];

export const relationImg = "https://readdy.ai/api/search-image?query=abstract%20minimal%20network%20visualization%20with%20fine%20connected%20nodes%20and%20thin%20lines%20on%20a%20deep%20charcoal%20warm%20background%2C%20small%20amber%20and%20vermilion%20glowing%20dots%20linked%20by%20delicate%20threads%2C%20editorial%20data%20journalism%20artwork%2C%20clean%20and%20restrained%2C%20moody%20soft%20lighting%2C%20no%20text%2C%20no%20faces%2C%20sophisticated%20minimal%20composition&width=1280&height=760&seq=relation-net-0908&orientation=landscape";

export const chatItems = [
  {
    who: "当事人 A · 语音转文字",
    snippet: "「……那笔钱你就别问了，怎么进来的不重要，重要的是别人查不到我头上。」",
    decipher: "截图原始语音转写，与公开募资口径明显冲突，指向某笔未公开资金往来。",
    status: "已交叉验证",
  },
  {
    who: "对接人 B · 文字对话",
    snippet: "「这件事你在外面一个字都别提，我们这边已经把相关的都处理掉了。」",
    decipher: "该对话中提及的时间节点，与一次公开离职声明存在精确吻合。",
    status: "待补证",
  },
  {
    who: "中间人 C · 深夜长语音",
    snippet: "「他本人确实不方便出面，你找我，对外就说是我们几个合伙做的。」",
    decipher: "「出面」代指的真实身份与此前报道的操盘角色高度一致，仍需实名佐证。",
    status: "进行中",
  },
];

export const chatImg = "https://readdy.ai/api/search-image?query=editorial%20still%20life%20photograph%20of%20a%20smartphone%20screen%20glowing%20softly%20in%20dim%20warm%20evening%20light%20showing%20an%20out%20of%20focus%20messaging%20interface%2C%20copy%20and%20icons%20blurred%20and%20indistinct%2C%20moody%20charcoal%20background%20with%20amber%20highlights%2C%20documentary%20mystery%20tone%2C%20cinematic%20depth%20of%20field%2C%20restrained%20minimal%20composition%2C%20no%20readable%20text&width=1280&height=760&seq=chat-phone-0908&orientation=landscape";

export const archives = [
  { time: "07-18", tag: "真实身份", title: "神秘运营主体实名复盘：从一支匿名账号开始", status: "已实锤", hot: false },
  { time: "07-02", tag: "背后金主", title: "三笔「天使资金」背后的同一张签名单", status: "进行中", hot: true },
  { time: "06-21", tag: "隐藏关系", title: "同车记录、同机行程与一张去关键化的合影", status: "已实锤", hot: false },
  { time: "06-09", tag: "私下聊天", title: "一段被删群聊的恢复与逐条解读", status: "待验证", hot: false },
  { time: "05-30", tag: "未公开信息", title: "未公开的商务协议里，那个被划掉的名字", status: "进行中", hot: true },
  { time: "05-14", tag: "人物关系", title: "离职高管与现任操盘者的三次同日航班", status: "辟谣反转", hot: false },
];

export const liveComments = [
  { name: "深水区潜水员", tag: "老深挖", text: "A 那条旧采访里说自己「从不投没见过的行业」，可融资公告里他名下的基金全是他从未涉足过的赛道——要么他对媒体撒谎，要么背后金主另有其人。", likes: 1264, replies: 342, hot: true },
  { name: "工商小能手", tag: "补刀者", text: "顺着地址迁移那条去查，发现三次注册都在同一天办结，间隔正好是公司年报发布日。这节奏也太规律了，希望编辑部往下追。", likes: 987, replies: 208, hot: true },
  { name: "吃瓜不站队", tag: "路人视角", text: "那张同框照我放大到像素级别了，背景里的招牌是七年前关门的店。所以这段隐藏关系的时间线，恐怕比现在传的还要早。", likes: 654, replies: 119, hot: false },
  { name: "线人甲", tag: "匿名投稿", text: "私下聊天那段语音我对比过本人访谈的语速和用词习惯，相似度很高。但实锤需要更硬的证据，建议编辑部再拉一条资金流水。", likes: 502, replies: 76, hot: false },
];

export const footerLinks = [
  { group: "深挖频道", items: ["真实身份", "背后金主", "隐藏关系", "私下聊天", "未公开信息"] },
  { group: "编辑部", items: ["关于呱呱", "报道原则", "线索规范", "纠错与辟谣", "联系我们"] },
  { group: "说明", items: ["免责声明", "转载规则", "信息来源", "隐私边界", "投稿与爆料"] },
];